import React, {useEffect, useState} from "react";
import ReactTable from "../../../components/ReactTableWrapper";

import connection from "../../../connection";
import Connection from "../../../connection";
import general from "../../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import AnexoAcontecimento from "components/AnexoAcontecimento/AnexoAcontecimento.jsx";

import SweetAlert from "../../../components/SweetAlertWrapper";

import percursosStyle from "assets/jss/material-dashboard-pro-react/views/percursosStyle";
import Add from "@material-ui/icons/Add";
import UserSearch from "../../../components/UserSearch";
import UserDetailsBox from "../../../components/UserDetailsBox";
import Datetime from "../../../components/DatetimeWrapper";
import Create from "@material-ui/icons/Create";
import Person from "@material-ui/icons/Person";
import List from "@material-ui/icons/List";
import Attachment from "@material-ui/icons/Attachment";
import NavPills from "../../../components/NavPills/NavPills";
import CustomInput from "../../../components/CustomInput/CustomInput";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Check from "@material-ui/icons/Check";
import Accordion from "../../../components/Accordion/Accordion";
import StateCircle from "../../../components/StateCircle";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faExclamationTriangle, faFileExcel, faPlus, faSearchPlus, faTimes, faTimesCircle, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import Table from "../../../components/Table/Table";
import Tooltip from "@material-ui/core/Tooltip";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import {Close, CloudDownload, Send} from "@material-ui/icons";
import EquipaFormacao from "../../../components/EquipaFormacao";
import Description from "@material-ui/icons/Description";
import moment from "moment";
import EditarRelatorio from "../PaginaPercurso/editar_relatorio";
import Parser from "html-react-parser";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import Masonry from "react-masonry-css";
import Delete from "@material-ui/icons/Delete";
import ReactDOM from "react-dom";
import EstadoUtilizador from "../../../components/EstadoUtilizador";
import CaixaFiltrosAcontecimento, {ProviderFiltrosAcontecimento, WidgetsFiltrosAcontecimento} from "../../../components/FiltrosAcontecimento/FiltrosAcontecimento";

const portal = document.createElement('div');
portal.classList.add('my-super-cool-portal');


if (!document.body) {
  throw new Error('body not ready for portal creation!');
}

document.body.appendChild(portal);

function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

const CardFormacao = (props) => {
  return <Draggable key={props.id} draggableId={"formacao_" + props.id} index={props.index}>
    {(
      {draggableProps, dragHandleProps: eventHandlers, innerRef},
      {isDragging}
    ) => {
      let children = <div ref={innerRef} {...draggableProps} {...eventHandlers} style={{...draggableProps.style, padding: "10px 0"}}><Card style={{margin: 0}}>
        <CardHeader color="info">
          <div style={{display: "flex", justifyContent: "space-between", padding: "5px 0"}}>
            <p style={{margin: 0}}>
              <StateCircle state={props.estado}/> #{general.pad(props.id, 5)} - {props.codigo_modulo} | {props.modulo}
            </p>
            <Button
              justIcon
              round
              simple
              onClick={() => {
                window.App.hist.push("/formacao/" + props.id);
              }}
              style={{margin: -10}}
              color="info"
              className="edit"
            >
              <FontAwesomeIcon icon={faSearchPlus}/>
            </Button>
          </div>
          <table width={"100%"}>
            <tbody>
            <tr>
              <td>
                <h6>Inscritos</h6>
                <span>{props.inscritos + (props.vagas ? " (" + props.vagas + " vagas)" : '')}</span>
              </td>
              <td>
                <h6>Participantes</h6>
                <span>{props.participantes}</span>
              </td>
              <td>
                <h6>Presentes</h6>
                <span>{props.presentes}</span>
              </td>
              <td>
                <h6>Formador</h6>
                <span>{general.Renderers.userRenderer(props.formador)}</span>
              </td>
            </tr>
            </tbody>
          </table>
          <div>
            De {general.Renderers.dateRenderer(props.data_inicio, {hide_timezone: true})} até {general.Renderers.dateRenderer(props.data_fim, {hide_timezone: true})}
          </div>
        </CardHeader>
      </Card></div>;

      const usePortal = isDragging;

      if (!usePortal) {
        return children;
      }

      // if dragging - put the item in a portal
      return ReactDOM.createPortal(children, portal);
    }}
  </Draggable>
}

const CardSessoes = ({percurso, classes, setModal, hideModal}) => {

  const [cursos, setCursos] = useState(null);

  const obterDados = async (percurso_id) => {
    let cursos_integrados = (await connection.get("percurso/curso/listagem", {percurso: percurso_id}))
    setCursos(cursos_integrados);
  }

  useEffect(() => {
    obterDados(percurso.id);
  }, [percurso.id]);

  if (!cursos) return null;

  return <div>
    {cursos.map(c => <CardFormacoes key={c.id} curso_integrado={c} classes={classes} setModal={setModal} hideModal={hideModal}/>)}
  </div>
}

const CardFormacoes = ({curso_integrado, classes, setModal, hideModal}) => {
  const [formacoes, setFormacoes] = useState(null);
  const [sessoes, setSessoes] = useState(null);
  const [curso, setCurso] = useState(null);

  const obterDados = async () => {
    connection.get("curso/detalhes", {curso_id: curso_integrado.id}).then(setCurso);
    connection.get("curso/formacao/listagem", {curso: curso_integrado.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
    connection.get("curso/sessao/listagem", {curso: curso_integrado.id}).then(setSessoes);
  }

  useEffect(() => {
    obterDados();
  }, []);


  if (!sessoes || !formacoes || !curso)
    return null;

  const editarSessao = async (sessao) => {

    let dados = {
      data_inicio: sessao.data_inicio,
      data_fim: sessao.data_fim,
      designacao: sessao.designacao
    };

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <p>As datas dos módulos serão editadas juntamente com as datas da sessão</p>
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            defaultValue: dados.designacao,
            onChange: (e) => {
              dados.designacao = e.target.value
            }
          }}
        />
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Data de início
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              dados.data_inicio = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={dados.data_inicio}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Data de fim
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              dados.data_fim = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={dados.data_fim}
          />
        </FormControl>
      </form>
    };

    setModal(<SweetAlert
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Editar Sessão</span>
      </div>)}
      onConfirm={async () => {
        await connection.post("curso/sessao/editar", {
          curso: curso.id,
          sessao: sessao.id,
          designacao: dados.designacao,
          data_inicio: dados.data_inicio,
          data_fim: dados.data_fim
        });
        hideModal();
        general.success("Sessão editada", "Sucesso");
        connection.get("curso/sessao/listagem", {curso: curso.id}).then(setSessoes);
      }}
      onCancel={() => hideModal()}
      cancelBtnText="Cancelar"
      showCancel
      confirmBtnText="Guardar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  };

  const criarSessao = async () => {
    await connection.post("curso/sessao/criar", {
      curso: curso.id,
    });

    general.success("Sessão criada", "Sucesso");

    connection.get("curso/sessao/listagem", {curso: curso.id}).then(setSessoes);
  }

  const confirmAlterarFormacao = async (formacao, reverter) => {
    // Alterar data de início e término da formação para ser coerente com a data de início e término da sessão
    let formacao_alterada = await connection.post("acontecimento/formacao/alterar_dados", {formacao: formacao.id, sessao: formacao.sessao, curso: curso.id});

    // Data de início e fim da sessão
    let inicio_sessao = moment(formacao_alterada.inicio_sessao).startOf('day').toDate();
    let fim_sessao = moment(formacao_alterada.fim_sessao).endOf('day').toDate();

    // Data de início e fim da formação
    formacao.data_inicio = formacao_alterada.data_inicio_formacao;
    formacao.data_fim = formacao_alterada.data_fim_formacao;

    setModal(
      <SweetAlert
        warning
        title="Confirmar alteração"
        onConfirm={() => {
          connection.post("curso/formacao/editar_sessao", {formacao: formacao.id, formacao_data_inicio: formacao.data_inicio, formacao_data_fim: formacao.data_fim, sessao: formacao.sessao, curso: curso.id}, (data) => {
            if (data.success) {
              general.success("Sessão do módulo alterada com sucesso.");
            } else {
              general.error(data.message, "Ocorreu um erro");
              reverter && reverter();
            }
            hideModal();
          })
        }}
        onCancel={() => {
          hideModal();
          reverter && reverter();
        }}
        confirmBtnCssClass={
          classes.button + " " + classes.danger
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Início do módulo
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              formacao.data_inicio = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={formacao.data_inicio}
            valid={(current) => {
              return current >= inicio_sessao && current <= fim_sessao
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Fim do módulo
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              formacao.data_fim = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={formacao.data_fim}
            valid={(current) => {
              return current >= inicio_sessao && current <= fim_sessao
            }}/>
        </FormControl>
        Atenção! Esta alteração irá modificar as datas em que o módulo irá ocorrer.
      </SweetAlert>
    );
  }

  const confirmApagarSessao = (sessao, confirm) => {
    const go = () => {
      connection.post("curso/sessao/apagar", {sessao: sessao, curso: curso.id}, (data) => {
        if (data.success) {
          general.success("Sessão apagada com sucesso.");
        } else {
          general.error(data.message, "Ocorreu um erro");
        }
        hideModal();
        connection.get("curso/sessao/listagem", {curso: curso.id}).then(setSessoes);
        connection.get("curso/formacao/listagem", {curso: curso.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
      })
    }

    if (!confirm)
      return go();

    setModal(
      <SweetAlert
        warning
        title="Apagar sessão?"
        onConfirm={() => {
          go();
        }}
        onCancel={() => {
          hideModal();
        }}
        confirmBtnCssClass={
          classes.button + " " + classes.danger
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Os módulos da sessão deixarão de estar agrupados, mas irão manter as propriedades atuais.
      </SweetAlert>
    );
  }

  const onDragEnd = ({source, destination, draggableId, ...rest}) => {
    if (!curso.pode_gerir)
      return;

    const sourceDrop = JSON.parse(source.droppableId.replace("sessao_", ""));
    const destinationDrop = JSON.parse(destination.droppableId.replace("sessao_", ""));

    let list = formacoes.filter(f => f.sessao === sourceDrop);
    let formacao = list[source.index];

    let changed = false;
    if (formacao.sessao !== destinationDrop) {
      formacao.sessao = destinationDrop;
      changed = true;
    }

    if (sourceDrop !== destinationDrop)
      list = formacoes.filter(f => f.sessao === destinationDrop);

    let originalSourceIdx = formacoes.findIndex(f => f === formacao);
    let originalDestinationIdx = formacoes.findIndex(f => f === list[destination.index]);
    setFormacoes(reorder(formacoes, originalSourceIdx, originalDestinationIdx));

    if (changed) {
      confirmAlterarFormacao(formacao, () => {
        connection.get("curso/formacao/listagem", {curso: curso.id}).then(formacoes => setFormacoes(formacoes.map((f, idx) => ({...f, index: idx}))));
      });
    }
  }

  let formacoes_sem_sessao = formacoes.filter(f => !f.sessao);

  let adicionar = curso.pode_gerir && <div style={{display: "flex", justifyContent: "center"}}>
    <div>
      <Button
        justIcon
        round
        simple
        style={{backgroundColor: "white", marginBottom: 10, marginTop: 25}}
        onClick={() => {
          criarSessao();
        }}
        color="primary"
        className={classes.addModuloButton}
      >
        <Add/>
      </Button>
      <p>Adicionar sessão</p>
    </div>
  </div>;

  return <DragDropContext onDragEnd={onDragEnd}>
    <div style={{overflow: "hidden"}}>
      <Masonry
        breakpointCols={{
          default: 2,
          600: 1
        }}
        className="cne-masonry-grid"
        columnClassName="cne-masonry-grid_column">
        {formacoes_sem_sessao.length > 0 && <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Sem sessão</h4>
            </div>
          </CardHeader>
          <Droppable droppableId={"sessao_null"}>
            {({innerRef, placeholder}, {isDraggingOver}) => (<>
              <div ref={innerRef}>
                {formacoes_sem_sessao.length > 0 && <CardBody>
                  {formacoes_sem_sessao.filter(f => !f.sessao).map((f, idx) => <CardFormacao key={f.id + "_" + idx} {...f} index={idx}/>)}
                </CardBody>}
                {formacoes_sem_sessao.length === 0 && <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
                  <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Arraste um módulo para remover a sessão</h5>
                </CardBody>}
              </div>
              {placeholder}
            </>)}
          </Droppable>
        </Card>}
        {sessoes.map(s => {
            let formacoes_sessao = formacoes.filter(f => f.sessao === s.id);
            return <Card key={s.id}>
              <CardHeader color="primary">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <h4 style={{flex: 1}}>{s.designacao}</h4>
                  {curso.pode_gerir && <>
                    <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={() => editarSessao(s)}>
                      <Create/> Editar
                    </Button>
                    <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={() => confirmApagarSessao(s.id, formacoes_sessao.length > 0)}>
                      <Delete/> Apagar
                    </Button>
                  </>}
                </div>
                {s.data_inicio && s.data_fim && <p>De {general.Renderers.dateRenderer(s.data_inicio, {hide_timezone: true})} até {general.Renderers.dateRenderer(s.data_fim, {hide_timezone: true})}</p>}
              </CardHeader>
              <Droppable droppableId={"sessao_" + s.id}>
                {({innerRef, placeholder}, {isDraggingOver}) => (<>
                  <div ref={innerRef}>
                    {formacoes_sessao.length > 0 && <CardBody>
                      {formacoes_sessao.map((f, idx) => <CardFormacao key={f.id + "_" + idx} {...f} index={idx} simples/>)}
                    </CardBody>}
                    {formacoes_sessao.length === 0 && <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
                      <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Arraste um módulo para esta sessão</h5>
                    </CardBody>}
                  </div>
                  {placeholder}
                </>)}
              </Droppable>
            </Card>
          }
        )}
        {sessoes.length <= 1 && adicionar}
      </Masonry>
      {sessoes.length > 1 && adicionar}
    </div>
  </DragDropContext>

};

class GestaoPercurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percurso: props.detalhes,
      participantes: {},
      participantesCursosIntegrados: null,
      modal: null,
    };

    this.hideModal = this.hideModal.bind(this);
    this.fecharPercurso = this.fecharPercurso.bind(this);
    this.inscreverFormando = this.inscreverFormando.bind(this);

    this.reloadParticipantesPercurso = async () => {
      let participantes = await connection.get("percurso/participantes/listagem", {id_percurso: this.state.percurso.id});

      let participantesCursosIntegrados = [];

      if (this.state.percurso.formacao_continua) {
        let cursos_integrados = await connection.get("percurso/curso/listagem", {percurso: this.state.percurso.id});

        cursos_integrados.map(async (curso) => {
          participantesCursosIntegrados.push(await connection.get("curso/participantes/listagem", {id_curso: curso.id}));
        });

        this.setState({
          participantesCursosIntegrados: participantesCursosIntegrados
        })
      }

      this.setState({
        participantes: participantes,
        modal: null
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {percurso: props.detalhes};
  }

  componentDidMount() {
    this.reloadParticipantesPercurso();
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  inscreverFormando() {
    const {classes} = this.props;

    let formando = null;
    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Inscrever Formando no Percurso</span>
        </div>)}
        onConfirm={() => {
          let url = !this.state.percurso.formacao_continua ? 'percurso/participante/inscrever' : 'percurso/continuos/participante/inscrever'
          connection.post(url, {percurso: this.state.percurso.id, formando: formando}, (data) => {
            this.reloadParticipantesPercurso();
            general.success("Formando inscrito com sucesso.", "Sucesso!");
          });
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Inscrever"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Formando"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              formando = user.NIN;
            }}
          />
        </form>
      </SweetAlert>)
    });
  }

  fecharPercurso() {
    const {location} = this.props;
    let percurso_id = location.pathname.split("/percurso/")[1];
    this.setState({
      modal: (<SweetAlert
        warning
        title="Fechar Percurso"
        onConfirm={() => {
          connection.post("percurso/fechar", {id_percurso: percurso_id}, (data) => {
            if (data.success) {
              this.hideModal();
              this.props.reloadDetalhes();
              general.success("Percurso fechado com sucesso.", "Sucesso!");
            } else {
              general.error("Por favor tente novamente mais tarde.", "Erro!")
            }
          })
        }}
        onCancel={() => this.hideModal()}
        confirmBtnCssClass={
          this.props.classes.button + " " + this.props.classes.danger
        }
        cancelBtnCssClass={
          this.props.classes.button
        }
        confirmBtnText="Fechar Percurso"
        cancelBtnText="Cancelar"
        showCancel
      >
        Atenção! Ao fechar este percurso, todos os formandos que não tenham obtido aprovação serão automaticamente reprovados.
      </SweetAlert>)
    })
  }

  editDetalhesPercurso = async () => {
    const {classes} = this.props;

    let regioes = await connection.get("regiao/listagem");
    let nucleos = await connection.get("nucleo/listagem");

    if (!regioes.find((reg) => reg.id === this.state.percurso.id_regiao))
      regioes.unshift({id: this.state.percurso.id_regiao || 0, designacao: this.state.percurso.regiao || 'Nenhuma'});
    if (!nucleos.find((nuc) => nuc.id === this.state.percurso.id_nucleo))
      nucleos.unshift({id: this.state.percurso.id_nucleo || 0, designacao: this.state.percurso.nucleo || 'Nenhum', regiao: null});

    let percurso = {
      nucleo: this.state.percurso.id_nucleo || 0,
      regiao: this.state.percurso.id_regiao || 0,
      diretor: this.state.percurso.diretor,
      designacao: this.state.percurso.designacao
    };

    let Content = () => {
      const [percurso_nucleo_state, setNucleoState] = useState(percurso.nucleo);
      const [percurso_regiao_state, setRegiaoState] = useState(percurso.regiao);
      const [simulacao, setSimulacao] = useState(null);

      let regiao_ativa = regioes.find((regiao) => regiao.id === percurso_regiao_state);

      const simular = async () => {
        try {
          let resultado = await connection.post("percurso/editar_detalhes?simulacao=1", {
            percurso: this.state.percurso.id,
            agrupamento: null,
            nucleo: percurso.nucleo || null,
            regiao: percurso.regiao || null,
            diretor: percurso.diretor.NIN,
            designacao: percurso.designacao
          }, null, null, {disableNotif: true, returnError: true});
          setSimulacao(resultado);
        } catch (e) {
          setSimulacao(e);
        }
      }

      useEffect(() => {
        simular();
      }, [percurso_regiao_state]);

      let mensagem = null;
      if (simulacao) {
        if (simulacao.success) {
          if (this.state.percurso.designacao !== simulacao.designacao)
            mensagem = <>A designação do percurso será alterada para: <b>{simulacao.designacao}</b></>;
        } else {
          mensagem = simulacao?.message;
        }
      }

      return <form autoComplete="off" className={classes.addForm}>
        {mensagem && <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={mensagem}
            color={simulacao.success ? "warning" : "danger"}
          />
        </div>}
        {general.userHasType("admin") && <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            defaultValue: percurso.designacao,
            onChange: (e) => {
              percurso.designacao = e.target.value
            }
          }}
        />}
        <UserSearch
          labelText="Diretor"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0"
          }}
          defaultUser={percurso.diretor}
          onFoundUser={(user) => {
            percurso.diretor = user
          }}
        />
        {general.userHasType("admin", "chefe_nacional") && <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Região
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={percurso_regiao_state}
            onChange={(event) => {
              if (percurso.regiao === event.target.value)
                return;
              percurso.nucleo = null;
              setNucleoState(null);
              percurso.regiao = event.target.value;
              setRegiaoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a região</MenuItem>
            {this.state.percurso.regiao && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhuma</MenuItem>}
            {regioes.map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>}
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Núcleo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={percurso_nucleo_state}
            onChange={(event) => {
              if (percurso.nucleo === event.target.value)
                return;
              percurso.nucleo = event.target.value;
              setNucleoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o núcleo</MenuItem>
            {this.state.percurso.nucleo && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhum</MenuItem>}
            {nucleos.filter(nucleo => regiao_ativa && nucleo.regiao === regiao_ativa.codigo || nucleo.id === 0).map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Detalhes</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("percurso/editar_detalhes", {
            percurso: this.state.percurso.id,
            agrupamento: null,
            nucleo: percurso.nucleo || null,
            regiao: percurso.regiao || null,
            diretor: percurso.diretor.NIN,
            designacao: percurso.designacao
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Percurso editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  promptModal = (designacao, instrucoes, valor, callback) => {
    const {classes} = this.props;

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar {designacao}</span>
        </div>)}
        onConfirm={() => callback(valor)}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <p>{instrucoes}</p>
          <CustomInput
            formControlProps={{
              fullWidth: true,
              style: {padding: 0, margin: 0}
            }}
            inputProps={{
              type: "text",
              multiline: true,
              defaultValue: valor,
              placeholder: "Escrever " + designacao.toLowerCase(),
              rows: 3,
              onChange: (e) => {
                valor = e.target.value
              }
            }}
          />
        </form>
      </SweetAlert>)
    });
  };

  editPropriedadesPercurso = async () => {
    const {classes} = this.props;

    let percurso = {
      data_inicio_percurso: this.state.percurso.data_inicio_percurso,
      data_fim_percurso: this.state.percurso.data_fim_percurso,
      designacao: this.state.percurso.designacao,
    };

    let Content = () => {
      const [dataInicioState, setDataInicioState] = useState(percurso.data_inicio_percurso);
      const [simulacao, setSimulacao] = useState(null);

      const simular = async (dataInicio) => {
        try {
          let resultado = await connection.post("percurso/editar_informacoes?simulacao=1", {
            percurso: this.state.percurso.id,
            data_inicio_percurso: dataInicio,
            data_fim_percurso: percurso.data_fim_percurso
          }, null, null, {disableNotif: true, returnError: true});
          setSimulacao(resultado);
        } catch (e) {
          setSimulacao(e);
        }
      };

      useEffect(() => {
        if (dataInicioState)
          simular(dataInicioState);
      }, [dataInicioState]);

      let mensagem = null;
      if (simulacao) {
        if (simulacao.success) {
          if (this.state.percurso.designacao !== simulacao.designacao)
            mensagem = <>O código do percurso será alterado para: <b>{simulacao.designacao}</b></>;
        } else {
          mensagem = simulacao?.message;
        }
      }

      return <form autoComplete="off" className={classes.addForm}>
        {mensagem && <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={mensagem}
            color={simulacao.success ? "warning" : "danger"}
          />
        </div>}
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Início do percurso
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              percurso.data_inicio_percurso = value;
              setDataInicioState(value);
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={false}
            defaultValue={percurso.data_inicio_percurso}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Fim do percurso
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              percurso.data_fim_percurso = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={false}
            defaultValue={percurso.data_fim_percurso}
          />
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Informações</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("percurso/editar_informacoes", {
            percurso: this.state.percurso.id,
            data_inicio_percurso: percurso.data_inicio_percurso,
            data_fim_percurso: percurso.data_fim_percurso
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Percurso editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  fecharPercurso = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    let Content = () => {
      return <>
        <p style={{marginTop: 10}}>Ao fechar este percurso, todos os participantes que ainda não concluíram o percurso ficarão com o estado não terminado.</p>
      </>
    }

    this.setState({
      modal: <SweetAlert
        warning
        title={"Fechar Percurso"}
        onConfirm={async () => {
          await connection.post("percurso/fechar", {percurso: percurso.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesPercurso();
          general.success("Percurso fechado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Fechar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>
    });
  }

  reverterFechoPercurso = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Reverter Fecho do Percurso"}
        onConfirm={async () => {
          await connection.post("percurso/reverter_fecho", {percurso: percurso.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesPercurso();
          general.success("Percurso reaberto com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>Ao reverter o fecho deste percurso...</p>
      </SweetAlert>
    });
  }

  avancarEstado = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Avançar estado"}
        onConfirm={async () => {
          await connection.post("percurso/avancar_estado", {percurso: percurso.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesPercurso();
          general.success("Estado alterado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 5}}>Para efeitos de demonstração, é possível avançar o estado do percurso em questão. Pretende alterar o estado para <strong>{percurso.estado?.proximo?.designation}</strong>?</p>
      </SweetAlert>
    });
  }

  render() {
    const {classes, location} = this.props;
    const {percurso} = this.state;
    return this.state.percurso ? (<div className={classes.cursosContainer}>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12} sm={5}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}><StateCircle state={percurso.estado}/>{(percurso.acontecimento_teste ? 'T.' : '') + percurso.designacao}</h4>
                {percurso.pode_gerir_detalhes && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editDetalhesPercurso}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.percursoDetails}>
              <table>
                <tbody>
                <tr>
                  <td>Tipo de percurso:</td>
                  <td>{percurso.tipo}</td>
                </tr>
                {percurso.percurso && <tr>
                  <td>Percurso:</td>
                  <td><span className="clickable" onClick={() => {
                    window.App.hist.push("/percurso/" + percurso.percurso.id);
                  }}>{percurso.percurso.designacao}</span></td>
                </tr>}
                {percurso.relatorio_os && <tr>
                  <td>OSR/ OSN:</td>
                  <td>{percurso.relatorio_os} ({moment(percurso.relatorio_os_data).format("DD/MM/YYYY")})</td>
                </tr>}
                <tr>
                  <td>Diretor:</td>
                  <td>{general.Renderers.userRenderer(percurso.diretor)}</td>
                </tr>
                <tr>
                  <td>Região:</td>
                  <td>{percurso.regiao || '-'}</td>
                </tr>
                <tr>
                  <td>Núcleo:</td>
                  <td>{percurso.nucleo || '-'}</td>
                </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
          <EquipaFormacao acontecimento={this.state.percurso}/>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Gestão de percurso</h4>
                {percurso.pode_gerir && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editPropriedadesPercurso}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.percursoDetails}>
              <table>
                <tbody>
                <tr>
                  <td>Início do percurso</td>
                  <td>{general.Renderers.dateRenderer(percurso.data_inicio_percurso)}</td>
                </tr>
                <tr>
                  <td>Fim do percurso</td>
                  <td>{general.Renderers.dateRenderer(percurso.data_fim_percurso)}</td>
                </tr>
                </tbody>
              </table>
              <hr style={{margin: "10px -20px 6px"}}/>
              <Accordion
                collapses={[
                  {
                    title: "Observações",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("Observações", "Defina de seguida as observações que deverão constar no relatório de percurso:", percurso.observacoes, async (valor) => {
                          await connection.post("percurso/editar_observacoes", {
                            percurso: this.state.percurso.id,
                            observacoes: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Observações editadas", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(percurso.observacoes || 'Clique no botão de editar para preencher as observações').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  },
                  {
                    title: "Imaginário Mística",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("Imaginário Mística", null, percurso.imaginario_mistica, async (valor) => {
                          await connection.post("percurso/editar_imaginario_mistica", {
                            percurso: this.state.percurso.id,
                            imaginario_mistica: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Informações editadas", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(percurso.imaginario_mistica || 'Clique no botão de editar para preencher as informações sobre Imaginario Mística').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  },
                  {
                    title: "Patrulhas Método",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("Patrulhas Método", null, percurso.patrulhas_metodo, async (valor) => {
                          await connection.post("percurso/editar_patrulhas_metodo", {
                            percurso: this.state.percurso.id,
                            patrulhas_metodo: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Informações editadas", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(percurso.patrulhas_metodo || 'Clique no botão de editar para preencher as informações sobre Patrulhas Método').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  }
                ]}
              />
              {percurso.pode_gerir && <div className={classes.percursoButtons}>
                {!percurso.data_submissao && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.ativarPercurso}>Submeter Percurso</Button>}
                {percurso.data_submissao && !percurso.data_ativacao && general.userHasPermission("percurso.aprovar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.aprovarPercurso}>Aprovar/Publicar Percurso</Button>}
                {percurso.estado?.can_advance && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.avancarEstado}>Avançar estado</Button>}
                {percurso.estado.code === general.estadosAcontecimento.A_DECORRER && general.userHasPermission("percurso.editar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.fecharPercurso}>Fechar Percurso</Button>}
                {percurso.estado.code === general.estadosAcontecimento.FECHADO && general.userHasType("admin") && general.userHasPermission("percurso.editar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.reverterFechoPercurso}>Reverter Fecho do Percurso</Button>}
                {/*<Button className={classes.button + " " + classes.warning + " " + classes.sm} size="sm" onClick={() => {
                }}>Fechar Percurso</Button>
                <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => {
                  let url = "reports/relatorio_percurso?percurso_id=" + percurso.id;
                  general.openReport(url);
                }}>Descarregar Relatório</Button>*/}
              </div>}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <NavPills
            color="primary"
            alignCenter
            tabs={(() => {
              let slides = [
                {
                  tabButton: "Participantes",
                  tabIcon: Person,
                  tabContent: () => {
                    return [<this.CardParticipantes/>];
                  }
                }
              ];
              if (!this.state.percurso.formacao_continua) {
                slides.unshift(
                  {
                    tabButton: "Cursos",
                    tabIcon: List,
                    tabContent: () => <this.CardCursos/>
                  }
                )
              }

              if (this.state.percurso.data_ativacao)
                slides.reverse();
              if (this.state.percurso.formacao_continua) {
                slides.unshift({
                  tabButton: "Sessões",
                  tabIcon: List,
                  tabContent: () => {
                    return <CardSessoes percurso={this.state.percurso} classes={this.props.classes} hideModal={this.hideModal} setModal={(m) => {
                      this.setState({modal: m})
                    }}/>
                  }
                })
              }
              if (this.state.percurso.estado.code >= general.estadosAcontecimento.FECHADO && general.userHasPermission("percurso.editar")) {
                slides.unshift({
                  tabButton: "Relatório",
                  tabIcon: Description,
                  tabContent: () => <this.CardRelatorio/>
                })
              }
              slides.push({
                tabButton: "Anexos",
                tabIcon: Attachment,
                tabContent: () => <AnexoAcontecimento id_acontecimento={this.state.percurso.acontecimento} setModal={m => this.setState({modal: m})}/>
              });
              return slides;
            })()}
          />
        </GridItem>
      </GridContainer>
    </div>) : (<span>Loading..</span>);
  }

  ativarPercurso = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    let error = null;
    try {
      await connection.get("percurso/validar_informacoes", {percurso: percurso.id}, null, null, {disableNotif: true, returnError: true});
    } catch (e) {
      error = e.message;
    }

    window.App.openModal(<SweetAlert
      warning
      title={"Submeter Percurso"}
      onConfirm={async () => {
        await connection.post("percurso/ativar", {percurso: percurso.id});
        window.App.hideModal();
        this.props.reloadDetalhes();
        general.success("Percurso submetido com sucesso.");
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Submeter"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm + (error ? " " + classes.disabled : "")
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      {error && <SnackbarContent
        message={error}
        color="warning"
      />}
      <p style={{marginTop: 10}}>Tem a certeza que pretende submeter o percurso em questão? Não poderá alterar a região e núcleo depois de o fazer e as modificações nas datas serão limitadas.
        <strong>O percurso ficará disponível para o público após revisão e aprovação nacional.</strong>
      </p>
      <p className={classes.percursoDetails}>Informações do percurso:
        <table>
          <tbody>
          <tr>
            <td>Região*:</td>
            <td>{percurso.regiao || '-'}</td>
          </tr>
          <tr>
            <td>Núcleo*:</td>
            <td>{percurso.nucleo || '-'}</td>
          </tr>
          <tr>
            <td>Início do percurso</td>
            <td>{general.Renderers.dateRenderer(percurso.data_inicio_percurso)}</td>
          </tr>
          <tr>
            <td>Fim do percurso</td>
            <td>{general.Renderers.dateRenderer(percurso.data_fim_percurso)}</td>
          </tr>
          </tbody>
        </table>
        <small>* não poderão ser modificados após publicação</small>
      </p>
    </SweetAlert>);
  };

  aprovarPercurso = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        showClose
        style_options={{position: 'absolute', top: '-130px'}}
        warning
        title={"Aprovar/Publicar Percurso"}
        onCancel={() => this.hideModal()}
        confirmBtnText={<>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.danger + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("percurso/rejeitar_submissao", {percurso: percurso.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Submissão rejeitada com sucesso.");
          }}>Rejeitar
          </button>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("percurso/aprovar", {percurso: percurso.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Percurso publicado com sucesso.");
          }}>Publicar
          </button>
        </>}
        confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
      >
        <p style={{marginTop: 10}}>Tem a certeza que pretende publicar o percurso em questão? O percurso ficará imediatamente disponível para o público.</p>
      </SweetAlert>
    });
  }

  CardParticipantes = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;
    const num_participantes = this.state.participantes.participantes?.length;

    const pode_adicionar_participante = (this.state.percurso.pode_gerir && this.state.percurso.estado.code >= general.estadosAcontecimento.PUBLICO && this.state.percurso.estado.code < general.estadosAcontecimento.FECHADO) && (!!this.state.percurso.acontecimento_teste || (!this.state.percurso.formacao_continua && general.userHasPermission("percurso.inscrever_recurso")) || (this.state.percurso.grupo_fluxo === 'PGL' && general.userHasPermission("percurso.inscrever_recurso")))
    const [filtroExportarListagem, setFiltroExportarListagem] = useState(null)

    const filtroAlterado = async (filtro, pesquisa) => {
      let filtragem = {...filtro};

      for (let key in filtragem)
        if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

      if (JSON.stringify(filtroExportarListagem) !== JSON.stringify(filtragem))
        setFiltroExportarListagem(filtragem);

      setFilter(pesquisa);
    }

    const pesquisarListaParticipantes = async () => {
      let participantes = await connection.get("percurso/participantes/listagem", {id_percurso: this.state.percurso.id, filtro: filtroExportarListagem});

      this.setState({
        participantes: participantes,
        modal: null
      })
    }

    useEffect(() => {
      pesquisarListaParticipantes();
    }, [filtroExportarListagem]);

    return <ProviderFiltrosAcontecimento acontecimento={'percurso'} percurso={this.state.percurso}
                                         atualizar={filtroAlterado}
                                         lista_filtros={['regiao', 'nucleo', 'agrupamento', 'fase']}><Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>{this.state.participantes.participantes?.length === 1 ? 'Participante' : 'Participantes'} {num_participantes > 0 ? `(${num_participantes})` : null}</h4>
          <WidgetsFiltrosAcontecimento/>

          {pode_adicionar_participante &&
            <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} onClick={() => this.inscreverFormando()}>
              <Add/> Adicionar Participante
            </Button>}
          {this.state.participantes.participantes?.length > 0 && <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                                                                    target={'_blank'}
                                                                    href={Connection.getFullUrl("percurso/participantes/listagem", {id_percurso: this.state.percurso.id, exportar_participantes: true, filtro: filtroExportarListagem})}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </a>}
        </div>
      </CardHeader>
      <CaixaFiltrosAcontecimento/>
      <ReactTable
        placeholder={"Este percurso ainda não tem participantes"}
        data={general.filterTable(this.state.participantes.participantes, filter)}
        minRows={1}
        SubComponent={(row) => <UserDetailsBox {...row.original} participantesCursosIntegrados={this.state.participantesCursosIntegrados} dataUrl={`percurso/participantes/detalhes?id_percurso=${this.state.percurso.id}&id=${row.original.id}`} reloadData={this.reloadParticipantesPercurso}/>}
        columns={[
          {
            Header: "Nome",
            accessor: "nome",
            maxWidth: 450,
            Cell: (row) => {
              return (
                <span>
                  {row.original.acoes_utilizador && row.original.acoes_utilizador.length > 0 && row.original.acoes_utilizador.find((a) => !a.optional === true) && <Tooltip
                    title={"Existem ações pendentes, expanda para ver mais"}
                    placement="top"
                  ><span><FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"}/> </span></Tooltip>}
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}> <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                </span>
              );
            }
          },
          {
            Header: "Registo aprovado",
            accessor: "data_aprovacao",
            Cell: general.Renderers.dateRenderer,
            maxWidth: 310
          },
          {
            Header: "Estado",
            accessor: "estados_utilizador_percurso",
            Cell: (row) => {
              if (row.original.estado_fluxo !== 'EM_PROGRESSO') {
                let estado = {
                  CANCELADO: {
                    designacao: "Cancelado",
                    icon: <FontAwesomeIcon icon={faTimes} color={"#f33a3a"}/>
                  },
                  TERMINADO: {
                    designacao: "Concluído",
                    icon: <FontAwesomeIcon icon={faCheck} color={"#11be33"}/>
                  },
                  NAO_TERMINADO: {
                    designacao: "Não concluído",
                    icon: <FontAwesomeIcon icon={faCheck} color={"#f33a3a"}/>
                  }
                }[row.original.estado_fluxo];
                if (!estado)
                  return null;
                return <span>{estado.icon} {estado.designacao}<br/></span>;
              }

              if (row.original.qualificacao_anulada_por)
                return <Tooltip
                  title={'Justificação: ' + row.original.justificacao_qualificacao_anulada}
                  placement={"top-start"}
                ><span><FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"}/> Qualificação anulada</span>
                </Tooltip>

              return row.value.map(estado => <span><FontAwesomeIcon icon={faCheck} color={"#1cacbf"}/> {estado.designacao}<br/></span>)
            }
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card></ProviderFiltrosAcontecimento>
  };

  CardCursos = () => {
    const {classes} = this.props;
    const [filter, setFilter] = useState("");

    let CursosTipoCurso = (props) => {
      const [cursos, setCursos] = useState(null);

      let reload = () => {
        connection.get("percurso/curso/listagem", {
          percurso: this.state.percurso.id,
          tipo: props.codigo
        }, (cursos) => {
          cursos = cursos.map((curso) => {
            return [
              <span><StateCircle state={curso.estado}/> {curso.descricao}</span>,
              general.Renderers.dateRenderer(curso.data_inicio_curso),
              general.Renderers.userRenderer(curso.diretor),
              curso.inscritos + (curso.vagas ? " (" + curso.vagas + " vagas)" : ''),
              curso.participantes,
              <div style={{margin: "-10px 0"}}>
                <Button
                  justIcon
                  round
                  simple
                  onClick={() => {
                    window.App.hist.push("/curso/" + curso.id);
                  }}
                  style={{margin: 0}}
                  color="info"
                  className="edit"
                >
                  <FontAwesomeIcon icon={faSearchPlus}/>
                </Button>
                {!curso.criar_unico && <Button
                  justIcon
                  round
                  simple
                  style={{margin: 0}}
                  onClick={() => {
                    this.apagarCurso(curso, () => reload())
                  }}
                  color="danger"
                  className="edit"
                >
                  <FontAwesomeIcon icon={faTrashAlt}/>
                </Button>}
              </div>
            ];
          });
          setCursos(cursos)
        });
      };

      if (cursos === null) {
        reload();
      }

      return <div style={{
        padding: "10px 0",
        boxShadow: "inset 0px 35px 10px -30px rgba(0, 50, 8, 0.12), inset 0px -35px 10px -30px rgba(0, 50, 8, 0.12)"
      }}>
        <Table
          customCellClasses={[classes.cursosUltimaColuna]}
          customClassesForCells={[5]}
          striped
          tableHeaderColor="primary"
          tableHead={["Curso", "Início", "Diretor", "Inscritos", "Participantes", ""]}
          tableData={cursos || []}
        />
        {this.state.percurso.pode_gerir && !props.criar_unico && <div style={{textAlign: "center", margin: "10px 0 5px"}}>
          <Button
            round
            onClick={() => {
              this.showNovoCursoModal(props.codigo, (novo_curso) => {
                connection.post("percurso/curso/novo", {
                  descricao: novo_curso.descricao,
                  modelo: novo_curso.modelo,
                  diretor: novo_curso.diretor,
                  percurso: this.state.percurso.id
                }, (data) => {
                  window.App.hideModal();
                  reload();
                  this.hideModal();
                  this.props.reloadDetalhes();
                });
              });
            }}
            color="success"
            className="remove"
          >
            <FontAwesomeIcon icon={faPlus}/> Adicionar curso
          </Button>
        </div>}
      </div>;
    };

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Cursos</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
        </div>
      </CardHeader>
      <ReactTable
        data={general.filterTable(this.state.percurso ? this.state.percurso.tipo_cursos : [], filter)}
        minRows={1}
        collapseOnDataChange={false}
        SubComponent={(row) => <CursosTipoCurso {...row.original}/>}
        columns={[
          {
            Header: "Tipo",
            accessor: "designacao"
          },
          {
            Header: "Cursos",
            accessor: "cursos",
            width: 150,
            Cell: (row) => row.value === 0 ? <span style={{color: "#ff8123"}}>Sem cursos</span> : row.value
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  }

  CardRelatorio = () => {
    const {classes} = this.props;
    const [dadosRelatorio, setDadosRelatorio] = useState(null);
    const [relatorioHTML, setRelatorioHTML] = useState(null);

    const obterDados = async () => {
      setDadosRelatorio(await connection.get("percurso/relatorio/dados", {percurso_id: this.state.percurso.id}));
      setRelatorioHTML(await connection.get("percurso/relatorio/obter_html", {percurso_id: this.state.percurso.id}, null, null, {disableNotif: true}));
    }

    useEffect(() => {
      if (this.state.percurso.estado.code >= general.estadosAcontecimento.FECHADO && general.userHasPermission("percurso.editar"))
        obterDados();
    }, []);

    if (!dadosRelatorio)
      return null;

    const percurso = this.state.percurso;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Relatório {percurso.relatorio_os && <small>Aceite, na OSN {percurso.relatorio_os} de {moment(percurso.relatorio_os_data).format("DD/MM/YYYY")}</small>}</h4>
          {dadosRelatorio.dados_completos && <>
            {!percurso.data_relatorio_submetido && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={() => {
              this.setState({
                modal: (<SweetAlert
                  title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
                    <span className={classes.modalCardTitle}>Editar Relatório</span>
                  </div>)}
                  style={{
                    width: 750, padding: 20
                  }}
                  onCancel={() => this.hideModal()}
                  cancelBtnText="Cancelar"
                  showCancel={false}
                  showConfirm={false}
                  showClose
                >
                  <EditarRelatorio dadosRelatorio={dadosRelatorio} classes={classes} idPercurso={this.state.percurso.id} onSubmit={() => {
                    this.hideModal();
                    obterDados();
                  }}/>
                </SweetAlert>)
              })
            }}>
              <Create/> Editar
            </Button>}
            <Button className={classes.addStuffButton + " " + classes.button + " " + classes.warning} onClick={() => {
              window.open(connection.getBase() + "percurso/relatorio/obter?percurso_id=" + this.state.percurso.id, "_blank");
            }}>
              <CloudDownload/> Descarregar
            </Button>
            {percurso.estado.code === general.estadosAcontecimento.FECHADO && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={this.submeterRelatorio}>
              <Send/> Submeter
            </Button>}
            {percurso.estado.code === general.estadosAcontecimento.RELATORIO_SUBMETIDO && <>
              {percurso.pode_aprovar_relatorio_preliminar && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={() => this.aprovarRelatorio(true)}>
                <Check/> Aprovar Preliminar
              </Button>}
              {percurso.pode_aprovar_relatorio && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.success} onClick={() => this.aprovarRelatorio(false)}>
                <Check/> Aprovar Final
              </Button>}
              {(percurso.pode_recusar_relatorio_preliminar || percurso.pode_recusar_relatorio) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={this.recusarRelatorio}>
                <Close/> Recusar
              </Button>}
            </>}
            {percurso.pode_reabrir_relatorio && percurso.estado.code === general.estadosAcontecimento.RELATORIO_ACEITE && <>
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={this.reabrirRelatorio}>
                <Close/> Reabrir
              </Button>
            </>}
          </>}
        </div>
      </CardHeader>
      <CardBody style={{padding: dadosRelatorio.dados_completos ? "35px" : undefined}}>
        {dadosRelatorio.dados_completos ? (relatorioHTML && Parser(relatorioHTML, {
          replace: domNode => {
            if (domNode.name === 'body')
              domNode.name = "div";
          }
        })) : <>
          <h4>Complete o seguinte formulário para emitir o relatório do percurso:</h4>
          <EditarRelatorio dadosRelatorio={dadosRelatorio} classes={classes} idPercurso={this.state.percurso.id} onSubmit={() => {
            obterDados();
          }}/>
        </>}
      </CardBody>
    </Card>
  };


  async showNovoCursoModal(tipo, callback) {
    const {classes} = this.props;

    let modelos = await connection.get("modelo/listagem", {tipo: tipo});

    let novo_curso = {
      modelo: modelos.length === 1 ? modelos[0].id : null,
      diretor: null,
      descricao: null
    };

    let Content = () => {
      const [modelo, setModelo] = useState(novo_curso.modelo);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código do Curso*"
          id="novoCurso-descricao"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "text",
            name: "novoCursoDescricao",
            onChange: (e) => {
              novo_curso.descricao = e.target.value;
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_curso" className={classes.selectLabel}>
            Modelo*
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo}
            onChange={(event) => {
              novo_curso.modelo = event.target.value;
              setModelo(event.target.value);
            }}
            inputProps={{
              name: "modelo_curso",
              id: "modelo_curso"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione o modelo</MenuItem>
            {modelos.map((modelo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modelo.id}>{modelo.designacao + (modelo.tags ? ' (' + modelo.tags + ')' : '')}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <UserSearch
          labelText="NIN do Diretor"
          id="novoCursoDiretor"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            name: "diretor"
          }}
          onFoundUser={(user) => {
            novo_curso.diretor = user.NIN
          }}
        />
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Novo Curso</span>
      </div>)}
      onConfirm={() => callback(novo_curso)}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Criar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      <Content/>
    </SweetAlert>);
  }

  apagarCurso = (curso, callback) => {
    window.App.openModal(<SweetAlert
      warning
      title="Apagar Curso"
      onConfirm={async () => {
        await connection.post("curso/apagar", {id: curso.id});
        window.App.hideModal();
        this.hideModal();
        this.props.reloadDetalhes();
        callback && callback();
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnCssClass={
        this.props.classes.button + " " + this.props.classes.danger
      }
      cancelBtnCssClass={
        this.props.classes.button
      }
      confirmBtnText="Apagar"
      cancelBtnText="Cancelar"
      showCancel
    >
      Atenção! Ao apagar este curso ({curso.descricao}) serão apagadas todas as informaões do mesmo. Não será possível apagar cursos que já têm participantes ou formações.
    </SweetAlert>);
  };


  submeterRelatorio = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Submeter relatório"}
        onConfirm={async () => {
          await connection.post("percurso/relatorio/submeter", {percurso_id: percurso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório submetido com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Submeter"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório será submetido para aprovação e não poderá voltar a ser editado, a menos que seja rejeitado.</p>
      </SweetAlert>
    });
  }

  aprovarRelatorio = async (preliminar) => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    let dados = {
      percurso_id: percurso.id,
      ordem_servico: percurso.relatorio_os || "",
      ordem_servico_data: percurso.relatorio_os_data || null
    }

    let url = preliminar ? "percurso/relatorio/aprovar_preliminar" : "percurso/relatorio/aprovar";

    this.setState({
      modal: <SweetAlert
        warning
        title={`Aprovar relatório`}
        onConfirm={async () => {
          if (preliminar && !dados.ordem_servico.trim()) {
            general.error("Indique a ordem de serviço.");
            return;
          }
          await connection.post(url, dados);
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório aprovado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Aprovar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório será marcado como aprovado e não poderá ser modificado novamente.</p>
        {preliminar && <>
          <CustomInput
            labelText="Ordem de serviço"
            disabled
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              defaultValue: dados.ordem_servico,
              onChange: (e) => {
                dados.ordem_servico = e.target.value
              }
            }}
          />
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data da Ordem de Serviço
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                dados.ordem_servico_data = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={false}
              defaultValue={dados.ordem_servico_data}
            />
          </FormControl>
        </>}
      </SweetAlert>
    });
  }

  recusarRelatorio = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Recusar relatório"}
        onConfirm={async () => {
          await connection.post("percurso/relatorio/recusar", {percurso_id: percurso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório recusado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Recusar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório voltará ao estado "pendente de submissão" para ser corrigido pelo diretor de percurso.</p>
      </SweetAlert>
    });
  }

  reabrirRelatorio = async () => {
    const {classes} = this.props;
    const percurso = this.state.percurso;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Reabrir relatório"}
        onConfirm={async () => {
          await connection.post("percurso/relatorio/reabrir", {percurso_id: percurso.id});
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Relatório reaberto com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Reabrir"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 10}}>O relatório voltará ao estado "pendente de submissão" e deverá ser submetido novamente pelo diretor de percurso.</p>
      </SweetAlert>
    });
  }
}

export default withStyles(percursosStyle)(GestaoPercurso);
